export default "* Sugerør – gerne den tykke variant med stor diameter. Minimum 6 stk. pr. elev\n* Bred tape\n* Lille stykke pap\n* Sprittusch";